import { useAffiliateBillingSelectOptions } from "components/UI/Selects/AffiliateBillingSelectSearchable/useAffiliateBillingSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

interface AffiliateBillingSelectSearchableProps extends SearchableSelectWrapperProps {
    includeTenantSettingOption?: boolean;
}

export const AffiliateBillingSelectSearchable = ({
    includeTenantSettingOption,
    ...props
}: AffiliateBillingSelectSearchableProps) => {
    const hookResult = useAffiliateBillingSelectOptions({ includeTenantSettingOption });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.affiliate_billing"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
